module.exports = __webpack_public_path__ + "img/icon_box_empty.5f463058.svg";